module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "page-wrap"
  }, [_c('div', {
    staticClass: "main-container symbols-page"
  }, [_c('div', {
    staticClass: "box-content"
  }, [_c('div', {
    staticClass: "box-content-inner"
  }, [_c('h2', {
    staticClass: "main-headline"
  }, [_vm._v("YOUR PROJECT. YOUR VISION.")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "back-button",
    attrs: {
      "tag": "a",
      "to": "/products"
    }
  }, [_vm._v("\n                        Back to products\n                    ")]), _vm._v(" "), _c('h6', {
    staticClass: "headline-sm"
  }, [_vm._v("SYMBOLS, GREEK CHARACTERS & CUSTOM LOGOS")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "subheadline"
  }, [_vm._v("\n                        With over 30+ years of experience, Fund Raisers, Ltd. has hand selected each product to\n                        "), _c('br'), _vm._v(" ensure that you receive only the best in the industry.\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                        In addition to the standard characters allowed, Fund Raisers, Ltd. allows small and large symbols,\n                        "), _c('br'), _vm._v(" Greek characters, and custom logos to be engraved.\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "symbols"
  }, [_c('div', {
    staticClass: "symbols-left"
  }, [_c('div', {
    staticClass: "small-symbols"
  }, [_c('p', [_c('strong', [_vm._v("Small Symbol Options")]), _vm._v(" (.5”) use 2 character spaces")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "images/Products-Page/symbols1.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "large-symbols"
  }, [_c('p', [_c('strong', [_vm._v("Large Symbol Options")]), _vm._v(" (1”) use 1 line of text")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "images/Products-Page/symbols2.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "greek-symbols"
  }, [_c('p', [_c('strong', [_vm._v("Greek Characters")]), _vm._v(" (.5”) use 2 character spaces")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "images/Products-Page/symbols3.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "custom-logo"
  }, [_c('strong', [_vm._v("Custom Logo")]), _vm._v(" "), _c('p', [_vm._v("\n                                    Add aesthetic value to your bricks for corporate sponsors\n                                    and high-level donations with custom artwork and logos!\n                                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "symbols-right"
  }, [_c('img', {
    attrs: {
      "src": "images/Products-Page/symbolssmall.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("Small Symbol")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "images/Products-Page/symbolslarge.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("Large Symbol")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "images/Products-Page/symbolsgreek.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("Greek Characters")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "images/Products-Page/symbolscustom.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("Custom Logo")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63f0e85e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/products/Symbols.vue
// module id = 1g5O
// module chunks = 1